import { createPortalApp, runPortalAuthResponseBridge } from '@equerranz/portal-shell';
import { createRoot } from 'react-dom/client';

import { portalModules } from './generated/portalModuleRegistry.js';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('index.html has no #root element to mount the portal into.');
}

const root = createRoot(container);

// The bridge first, always. When this document is the redirect URI carrying an authentication response, it
// hands the response back to the window that started the sign-in and the application must not mount here.
// Follows EquerraNZ/eq-portal's own web/apps/shell/src/main.tsx exactly: this repository has no shell of its
// own to design against, so this is the framework's own worked example, adapted for this portal's name and
// its one composed module.
runPortalAuthResponseBridge()
  .then(async (handled) => {
    if (handled) {
      return;
    }

    // The generated registry, never a literal list: it is written from this app's own module dependencies, so
    // adding a module to this portal is a dependency line and this file does not change.
    root.render(
      await createPortalApp({ portalName: 'Farmland Foods', modules: portalModules }),
    );
  })
  .catch((failure: unknown) => {
    // createPortalApp returns the fail-closed screen for a configuration failure, so anything reaching
    // here is a fault the portal cannot describe from inside itself.
    root.render(<pre>The portal failed to start: {String(failure)}</pre>);
  });
